<template>
<div>
    <Breadcrumbs main="Admin" title="Submitted Contents" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
            
                    
                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                                    <b-input-group class="datatable-btn">
                                        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                        <b-input-group-append>
                                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </div>

                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                       
                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>
                                     <template #cell(title)="data">
                                      <div v-if="data.item.title">
                                         <p> {{ data.item.title }}</p>
                                      </div>
                                    </template>
                                    <template #cell(name)="data">
                                      <div v-if="data.item.first_name || data.item.last_name">
                                         <p> {{ data.item.first_name }} {{ data.item.last_name }}</p>
                                      </div>
                                    </template>
                                    <template #cell(email)="data">
                                      <div v-if="data.item.email">
                                         <p> {{ data.item.email }}</p>
                                      </div>
                                    </template>
                                
                                    <template #cell(action)="data">
                                            <feather type="eye" size="22px" style="color: #0E7459; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-details  @click="detailContent(data.item)" title="Details"></feather>
                                    </template>
                                
                                    
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Details Modal -->
    <b-modal id="modal-center-details" centered hide-header size="lg">
        <div class="mt-4 mb-4 font-weight-bold" style="font-size: large;">Submitted Details</div>

        <div class="row mb-3">
            <div class="col-sm-12 d-flex flex-column">
                <span class="font-weight-bold">Title</span>
                <span>{{ contents.title }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Name</span>
                <span>{{ contents.first_name }} {{ contents.last_name }}</span>
            </div>
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Email</span>
                <span>{{ contents.email }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Phone</span>
                <span>{{ contents.phone }}</span>
            </div>
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Gender</span>
                <span class="text-capitalize">{{ contents.gender ? contents.gender : '-' }}</span>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Hashtags</span>
                <span>{{ contents.hashtags }}</span>
            </div>
            
        </div>
        <div class="row mb-3">
            <div class="col-sm-6 d-flex flex-column">
                <span class="font-weight-bold">Links</span>
                <a :href="contents.link" target="_blank" rel="noopener noreferrer" class="font-weight-semibold" style="color: #0B81FF;">{{ contents.link }}</a>
            </div>
            
        </div>
    </b-modal>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import js from '../../../auth/js';
import {
    myHost
} from '../../../_helpers/host'
import loader from '../loader/loader.vue'
export default {
    components: {
        loader,
    },
    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
               
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Name',
                    sortable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true
                },
             
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            filter: null,
            delete_value: null,

            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            contents:{
                id:'',
                first_name:'',
                last_name:'',
                email:'',
                phone:'',
                gender:'',
                title:'',
                hashtags:'',
                link:'',
            }
        };
    },

    computed: {
        ...mapState({
            items: state => state.voice.voice,
            loading: state => state.voice.voiceLoading,
            error: state => state.voice.voiceError,
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {

        this.$store.dispatch("voice/fetchVoice").then(() => {
            this.totalRows = this.items.length;

        });

    },

    watch: {

    },

    methods: {
        detailContent(data){
            this.contents.id = data.id ? data.id : ''
            this.contents.first_name = data.first_name ? data.first_name : ''
            this.contents.last_name = data.last_name ? data.last_name : ''
            this.contents.email = data.email ? data.email : ''
            this.contents.phone = data.phone ? data.phone : ''
            this.contents.gender = data.gender ? data.gender : ''
            this.contents.title = data.title ? data.title : ''
            this.contents.hashtags = data.hashtags ? data.hashtags : ''
            this.contents.link = data.link ? data.link : ''
        },
        toggleNews(data) {
            this.$store.dispatch("news/newsCustomToggle", {
                news_slug: data,


            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.udate_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },


        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            } else {
                return text;
            }
        },

        resetModal() {
            this.selectedStatus = ''
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        // deleteNews(id) {
        //     this.delete_value = id
        // },

        // handleDeleteOk() {
        //     this.$store.dispatch("news/deleteNews", {
        //         delete: this.delete_value,
        //     }).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });

        //             this.delete_value = null

        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //     })
        // },

    }
};
</script>

<style scoped>
.header-mobile {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (max-width: 460px) {
    .header-mobile {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: start;
    }
}
</style>
